import $ from "jquery";
import Dropzone from "dropzone";
import "dropzone/dist/dropzone.css";
import { course } from "../modules/course";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";
import { services } from "../services/notificationService";

function init() {
    const courseId = $("#courseId").val();
    const previewNode = document.querySelector("#Template");
    previewNode.id = "";
    const previewTemplate = previewNode.parentNode.innerHTML;
    previewNode.parentNode.removeChild(previewNode);

    const myDropzone = Dropzone.forElement("#Uploader");

    myDropzone.options.addRemoveLinks = true;
    myDropzone.options.autoProcessQueue = false;
    myDropzone.options.disablePreview = true;
    myDropzone.options.parallelUploads = 100;
    myDropzone.options.uploadMultiple = true;
    myDropzone.options.previewTemplate = previewTemplate;
    myDropzone.options.previewsContainer = "#PreviewTemplateParent";

    myDropzone.on("queuecomplete", function() {
        this.removeAllFiles();
    });

    myDropzone.on("error", function (file, response) {
        services.notificationService.error(response);
    });

    myDropzone.on("success", function (file, response) {
        $("#TablePartial").html(response);
    });

    myDropzone.on("addedfile", function() {
        if (this.files.length > 0) {
            $("#UploadBtn").show();
        }
    });

    myDropzone.on("removedfile", function() {
        if (this.files.length === 0) {
            $("#UploadBtn").hide();
        }
    });

    myDropzone.on("sending", function (file, xhr, formData) {
        formData.append("CourseId", courseId);
    });

    myDropzone.on("complete", function() {
        forms.enableSubmitButton();
        course.checkLoaRequired();
        forms.hideSpinner();
    });

    $("#UploadBtn").click(function () {
        let isValid = true;

        $(".dz-preview").each(function (index, item) {
            $(this).find("select[name=FileCategoryIds]").removeClass("error text-danger");
            $(this).find(".dz-error-message").hide();
            $(this).find(".js-val-error").text("");

            const selectValue = $(this).find("select[name=FileCategoryIds]").val();

            if (selectValue === "" || selectValue === undefined) {
                isValid = false;
                $(this).find("select[name=FileCategoryIds]").addClass("error text-danger");
                $(this).find(".js-val-error").text("File Category is required.");
            }
        });

        if (isValid) {
            forms.disableSubmitButton();
            forms.showSpinner("Uploading...", false);
            myDropzone.processQueue();
        }
    });

    $(document).on("click", "#aPrintDisclosureList", function() {
        printDisclosureForm(courseId);
    });

    $(document).on("click", ".js-print-doc", openCourseProgramDocument);

    $(document).on("click", "#selectAllFilesToggle", function() {
        selectAllFilesToggle();
    });

    $("#downloadFiles").click(function() {
        const chk = $(".chk-document-row:checked").map(function () { return $(this).val(); }).get();
        window.location.href = "/Course/DownloadFiles/" + JSON.stringify(chk);
    });

    $(".chk-document-row").click(function () { showHideDownloadFiles(); });

    $(document).on("click", ".document-remove", function() {
        $(this).removeClass("document-remove");
        const $row = $(this).closest("tr");
        const uploadId = $row.find("[type=checkbox]").val();
        dataaccess.delete({ url: "/Course/RemoveUpload/" + uploadId })
            .done(function () {
                $row.remove();
                course.checkLoaRequired();
            });
    });
}

function showHideDownloadFiles() {
    const chk = $(".chk-document-row:checked");
    if (chk.length > 0) {
        $("#downloadFiles").show();
    } else {
        $("#downloadFiles").hide();
    }
}

function selectAllFilesToggle() {
    const checkboxes = $(".chk-document-row");
    checkboxes.prop("checked", $("#selectAllFilesToggle").is(":checked"));
    showHideDownloadFiles();
}

function printDisclosureForm(courseId) {
    const url = "/Course/" + courseId + "/disclosureList/";
    forms.openPrintWindow(url);
}

function openCourseProgramDocument(e) {
    e.preventDefault();
    const url = $(this).attr("href");

    if (url.endsWith(".pdf")) {
        forms.openPrintWindow(url);
    } else {
        window.location.href = url;
    }
}

export const courseDocuments = {
    init: init
};